export default __webpack_public_path__ + "static/media/not-operate.b876412d.png";